import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// ADMIN NOTIFICATION APIS
// Controller: Adminnotifications.php
// ================================

// 1) Get Notifications List
export async function getNotifications(admin_id) {
  try {
    const fd = new FormData();
    fd.append("admin_id", admin_id);

    const res = await axios.post(
      `${apiBaseUrl}admin/notifications/list`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 2) Mark Single Notification Read
export async function markRead(notification_id) {
  try {
    const fd = new FormData();
    fd.append("notification_id", notification_id);

    const res = await axios.post(
      `${apiBaseUrl}admin/notifications/read`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 3) Get Unread Count
export async function unreadCount(admin_id) {
  try {
    const fd = new FormData();
    fd.append("admin_id", admin_id);

    const res = await axios.post(
      `${apiBaseUrl}admin/notifications/unread_count`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}
